import { allpeepNoPayloadEndpoint } from './helpers.js';
export const plugins = (rawClient) => ({
    list: allpeepNoPayloadEndpoint(rawClient, '/plugins'),
    config: allpeepNoPayloadEndpoint(rawClient, '/plugins/config'),
    manifest: allpeepNoPayloadEndpoint(rawClient, '/plugins/manifest'),
});
